import { render } from "./AddFolderModal.vue?vue&type=template&id=3081f44a"
import script from "./AddFolderModal.vue?vue&type=script&lang=js"
export * from "./AddFolderModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__